import Thread from "@/domain/entities/emails/Thread";
import { MailThread } from "@cs_teamwaydev/mailvista-sdk_react";
import { emailMapper } from "./emailMapper";

const threadMapper = (thread: MailThread): Thread =>
    new Thread({
        mails: thread.map(emailMapper),
    });

export default threadMapper;
